var _g, _rect, _path, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTopProductsChartIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 554,
    height: 339,
    viewBox: "0 0 554 339",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#ps5l73g7la)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.278,
    y: 10,
    width: 523.722,
    height: 308.978,
    rx: 19.13,
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.864,
    y: 13.587,
    width: 516.549,
    height: 301.804,
    rx: 15.543,
    stroke: "#fff",
    strokeWidth: 7.174
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 48.758,
    y: 41.087,
    width: 457.463,
    height: 251.333,
    rx: 9.565,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.376 67.813V57.635H68.66v-1.54h9.056v1.54H74v10.178h-1.624zm8.795-8.336c.78 0 1.49.19 2.125.569a3.961 3.961 0 0 1 1.524 1.54c.38.647.569 1.367.569 2.16 0 .78-.19 1.494-.57 2.142a4.117 4.117 0 0 1-1.523 1.54 4.165 4.165 0 0 1-2.125.552 4.256 4.256 0 0 1-2.143-.552 4.245 4.245 0 0 1-1.54-1.54 4.257 4.257 0 0 1-.552-2.143c0-.792.184-1.512.552-2.16a4.117 4.117 0 0 1 1.523-1.54 4.19 4.19 0 0 1 2.16-.568zm-2.746 4.268c0 .514.123.982.369 1.406.245.413.574.742.987.988.424.245.887.368 1.39.368.49 0 .948-.123 1.372-.368a2.75 2.75 0 0 0 1.005-.988c.245-.424.368-.892.368-1.406 0-.513-.123-.982-.368-1.406a2.675 2.675 0 0 0-1.005-1.021 2.693 2.693 0 0 0-1.372-.368c-.503 0-.966.122-1.39.368a2.714 2.714 0 0 0-.987 1.021 2.756 2.756 0 0 0-.369 1.406zm13.008-2.795c-.748 0-1.379.228-1.892.686-.513.458-.809 1.049-.887 1.774v.636c.078.726.374 1.317.887 1.775.513.457 1.144.686 1.892.686a2.755 2.755 0 0 0 2.41-1.373c.245-.424.368-.892.368-1.406a2.755 2.755 0 0 0-1.372-2.41 2.755 2.755 0 0 0-1.406-.368zm-4.336-1.306h1.557v1.64a3.273 3.273 0 0 1 1.239-1.339c.535-.312 1.154-.468 1.858-.468.725 0 1.389.19 1.992.569.613.38 1.093.898 1.44 1.557.356.647.535 1.355.535 2.125s-.179 1.485-.536 2.143a3.984 3.984 0 0 1-1.44 1.54c-.602.38-1.266.57-1.991.57-.704 0-1.323-.157-1.858-.47a3.272 3.272 0 0 1-1.24-1.339v4.603h-1.556v-11.13zm18.809 1.892c.558 0 1.027-.19 1.406-.57.391-.379.586-.842.586-1.389s-.195-1.004-.586-1.372c-.379-.38-.848-.57-1.406-.57h-2.879v3.9h2.879zm-4.503-5.44h4.503c.681 0 1.294.15 1.841.451.547.302.977.72 1.289 1.256.313.524.469 1.116.469 1.774 0 .659-.156 1.256-.469 1.791a3.476 3.476 0 0 1-1.289 1.256 3.75 3.75 0 0 1-1.841.452h-2.879v4.737h-1.624V56.095zm9.593 3.548h1.557v1.189c.245-.425.558-.754.937-.988a2.49 2.49 0 0 1 1.306-.352c.268 0 .519.034.753.1v1.424a2.53 2.53 0 0 0-.804-.134 2.11 2.11 0 0 0-1.573.653c-.413.424-.619.982-.619 1.673v4.604h-1.557v-8.169zm9.178-.167c.781 0 1.49.19 2.126.569a3.96 3.96 0 0 1 1.523 1.54c.379.647.569 1.367.569 2.16 0 .78-.19 1.494-.569 2.142a4.116 4.116 0 0 1-1.523 1.54 4.166 4.166 0 0 1-2.126.552 4.257 4.257 0 0 1-2.143-.552 4.252 4.252 0 0 1-1.54-1.54 4.26 4.26 0 0 1-.552-2.143c0-.792.184-1.512.552-2.16a4.122 4.122 0 0 1 1.523-1.54 4.193 4.193 0 0 1 2.16-.568zm-2.745 4.268c0 .514.122.982.368 1.406.245.413.575.742.987.988.424.245.888.368 1.39.368a2.69 2.69 0 0 0 1.372-.368 2.756 2.756 0 0 0 1.005-.988 2.76 2.76 0 0 0 .368-1.406 2.76 2.76 0 0 0-.368-1.406 2.681 2.681 0 0 0-1.005-1.021 2.691 2.691 0 0 0-1.372-.368c-.502 0-.966.122-1.39.368a2.716 2.716 0 0 0-.987 1.021 2.75 2.75 0 0 0-.368 1.406zm12.325 2.762c.748 0 1.378-.229 1.892-.686.513-.458.809-1.05.887-1.775v-.636c-.078-.725-.374-1.316-.887-1.774-.514-.458-1.144-.686-1.892-.686-.513 0-.982.122-1.406.368a2.751 2.751 0 0 0-1.373 2.41 2.751 2.751 0 0 0 1.373 2.41c.424.246.893.37 1.406.37zm-4.285-2.779c0-.77.173-1.478.519-2.125a4.125 4.125 0 0 1 1.439-1.557 3.75 3.75 0 0 1 2.009-.57c.703 0 1.317.157 1.841.47.536.312.954.758 1.256 1.339v-5.19h1.556v11.718h-1.556v-1.64a3.24 3.24 0 0 1-1.256 1.338c-.524.313-1.138.47-1.841.47a3.75 3.75 0 0 1-2.009-.57 4.159 4.159 0 0 1-1.439-1.54 4.536 4.536 0 0 1-.519-2.143zm16.809 2.645a2.85 2.85 0 0 1-1.071 1.189c-.447.279-.966.418-1.557.418-1.049 0-1.88-.33-2.494-.987-.614-.659-.921-1.552-.921-2.679v-4.67h1.557v4.503c0 .714.201 1.289.603 1.724.401.424.937.636 1.606.636.681 0 1.228-.212 1.641-.636.424-.435.636-1.01.636-1.724l.017-4.503h1.54v8.169h-1.557v-1.44zm7.483 1.607a4.257 4.257 0 0 1-2.143-.552 4.284 4.284 0 0 1-1.523-1.54 4.26 4.26 0 0 1-.552-2.143c0-.792.184-1.512.552-2.16a4.115 4.115 0 0 1 1.523-1.54 4.16 4.16 0 0 1 2.143-.568c.625 0 1.216.128 1.774.385a3.637 3.637 0 0 1 1.373 1.071c.368.458.597.965.686 1.523h-1.573c-.112-.435-.385-.792-.821-1.071a2.489 2.489 0 0 0-1.439-.435c-.502 0-.96.122-1.373.368-.413.245-.742.58-.987 1.004a2.885 2.885 0 0 0-.352 1.423c0 .514.117.982.352 1.406.245.413.574.742.987.988.413.245.871.368 1.373.368.547 0 1.032-.145 1.456-.435.435-.301.709-.68.82-1.138h1.557a3.189 3.189 0 0 1-.67 1.573c-.357.458-.814.82-1.372 1.088a4.234 4.234 0 0 1-1.791.385zm9.133-.067c-.881 0-1.579-.257-2.092-.77-.513-.513-.77-1.255-.77-2.226v-3.8h-1.59v-1.473h1.59v-2.21h1.54v2.21h2.209v1.473h-2.209v3.766c0 .547.145.949.435 1.206.29.245.692.368 1.205.368.235 0 .424-.022.569-.067v1.423c-.245.067-.541.1-.887.1zm5.345.067c-.96 0-1.752-.24-2.377-.72-.625-.48-.977-1.132-1.055-1.958h1.473c.056.402.257.725.603.97.346.246.775.369 1.289.369.502 0 .904-.106 1.205-.318.312-.212.469-.491.469-.837 0-.402-.168-.686-.503-.854-.334-.167-.848-.318-1.54-.452a11.44 11.44 0 0 1-1.473-.385 2.325 2.325 0 0 1-.954-.652c-.256-.302-.385-.72-.385-1.256 0-.703.274-1.278.821-1.724.546-.457 1.272-.686 2.176-.686.837 0 1.556.223 2.159.67.614.434.971 1.032 1.071 1.79h-1.557c-.055-.334-.239-.608-.552-.82-.312-.223-.697-.335-1.155-.335-.435 0-.787.09-1.054.268-.268.179-.402.419-.402.72 0 .257.084.463.251.62.167.155.374.273.619.35.246.068.597.146 1.055.235.614.112 1.116.24 1.506.385.391.134.726.368 1.005.703.279.335.418.798.418 1.39 0 .48-.139.915-.418 1.305-.268.38-.642.68-1.122.904a3.775 3.775 0 0 1-1.573.318z",
    fill: "#8C8C8C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 179.082,
    y: 91.985,
    width: 13.152,
    height: 13.152,
    rx: 3.587,
    fill: "#4270EB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 197.017,
    y: 96.17,
    width: 50.217,
    height: 4.783,
    rx: 2.391,
    fill: "#909090"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 257.995,
    y: 91.985,
    width: 13.152,
    height: 13.152,
    rx: 3.587,
    fill: "#08D4B8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 275.929,
    y: 96.17,
    width: 50.217,
    height: 4.783,
    rx: 2.391,
    fill: "#909090"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 341.223,
    y: 93.181,
    width: 10.761,
    height: 10.761,
    rx: 2.391,
    fill: "#fff",
    stroke: "#8CA1FF",
    strokeWidth: 2.391
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 357.962,
    y: 96.17,
    width: 50.217,
    height: 4.783,
    rx: 2.391,
    fill: "#909090"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFEFEF",
    strokeWidth: 3.1,
    d: "M94.428 99.504v168.929"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#EFEFEF",
    strokeWidth: 2.919,
    d: "M467.972 269.82H92.878"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#0530A6",
    d: "M109.735 170.216h11.956v77.717h-11.956z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#4270EB",
    d: "M109.735 118.803h11.956v51.413h-11.956z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#0530A6",
    d: "M147.996 204.889h10.761v43.043h-10.761z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#4270EB",
    d: "M147.996 151.086h10.761v53.804h-10.761z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#0530A6",
    d: "M183.719 170.422h11.434v78.09h-11.434z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#4270EB",
    d: "M183.865 141.521h10.761v29.891h-10.761z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#0530A6",
    d: "M219.734 209.672h11.956v38.261h-11.956z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#4270EB",
    d: "M219.734 174.998h11.956v34.674h-11.956z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#0530A6",
    d: "M255.604 201.302h11.956v46.63h-11.956z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#4270EB",
    d: "M255.603 190.542h11.956v10.761h-11.956z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#0530A6",
    d: "M293.864 194.129h10.761v53.804h-10.761z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#4270EB",
    d: "M293.864 164.238h10.761v29.891h-10.761z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#0530A6",
    d: "M329.733 148.694h11.956v99.238h-11.956z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#4270EB",
    d: "M329.733 118.803h11.956v29.891h-11.956z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#0530A6",
    d: "M365.602 216.846h11.956v31.087h-11.956z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#4270EB",
    d: "M365.602 195.324h11.956v21.521h-11.956z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#0530A6",
    d: "M402.667 160.651h10.761v87.282h-10.761z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#4270EB",
    d: "M402.667 143.912h10.761v17.935h-10.761z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#0530A6",
    d: "M436.145 177.39h11.956v70.543h-11.956z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#4270EB",
    d: "M436.145 130.76h11.956v47.826h-11.956z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#08D4B8",
    d: "M121.464 137.752h10.164v110.76h-10.164zM158.944 176.797h10.164v71.715h-10.164zM195.153 187.953h10.164v60.559h-10.164zM231.362 198.311h10.164v50.201h-10.164zM267.571 230.982h10.164v17.53h-10.164zM305.051 232.575h10.164v15.937h-10.164zM377.559 201.302h9.565v46.63h-9.565zM341.689 176.194h9.565v71.738h-9.565zM413.428 224.02h10.761v23.913h-10.761zM448.102 204.889h9.565v43.043h-9.565z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m446.308 140.325-34.076 31.086h-43.043l-33.478-46.63-33.478 41.657-36.467 14.539-37.065-36.467-34.673 42.445-41.848-57.989-30.716 37.472",
    stroke: "#8CA1FF",
    strokeWidth: 2.391,
    strokeLinejoin: "round",
    strokeDasharray: "4.78 4.78"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "ps5l73g7la",
    x: 0.93,
    y: 0.435,
    width: 552.418,
    height: 337.673,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.783
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.174
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_876_980"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_876_980",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopProductsChartIllustration);
export default __webpack_public_path__ + "static/media/top-products-chart-illustration.eb89888e052426e24172d1cf29ed65d0.svg";
export { ForwardRef as ReactComponent };